// Helper: capitalize the first letter of every word (keeps the rest unchanged)
export function capWords(el) {
  const v = el.value;
  // Uppercase letters at word boundaries (handles accents too)
  const capped = v.replace(/\b([A-Za-zÀ-ÖØ-öø-ÿ])/g, (m) => m.toUpperCase());
  if (v !== capped) {
    const start = el.selectionStart;
    const end   = el.selectionEnd;
    el.value = capped;
    // preserve caret/selection
    el.setSelectionRange(start, end);
  }
};